import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  LinkIcon,
} from '../../components'
import Styles from './IyvListTutorial.css'


@CSSModules(Styles, {allowMultiple:true})
class IyvListTutorialOverlay extends Component {
  static propTypes = {
    showTutorial: PropTypes.bool,
    clickCloseTutorial: PropTypes.func
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return this.props.showTutorial ?
      <div
        styleName='tutorial-overlay'
        onClick={this.props.clickCloseTutorial}
      /> :
      null
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTutorial extends Component {
  static propTypes = {
    showTutorial: PropTypes.bool,
    currentTutorial: PropTypes.number,
    clickPrevTutorial: PropTypes.func,
    clickNextTutorial: PropTypes.func,
    clickCloseTutorial: PropTypes.func,
  }
  //
  constructor(props) {
    super(props)
    //
    const tutorialStep1 = [
      {
        headline: 'Step 1: Getting started',
        copy: 'If you know what you\'re looking for, search for funds ' +
          'using the search field. You can search by fund name, ticker ' +
          'symbol, or asset manager.'
      }
    ]
    const tutorialSteps3 = [
      {
        headline: 'Step 3: Filter your results',
        copy: 'Looking for a certain type of fund? Filter your results by ' +
          'selecting asset managers, fund categories, or other search ' +
          'criteria.'
      }
    ]
    const tutorialContent = {
      'Invest Your Values' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'Click the column headers to sort the results. Click a ' +
            'row to see the full profile for that fund.'
        }
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds.'
        }
      ]),
      'Weapon Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a military weapon grade, and the ' +
            'percentage of the fund\'s assets invested in arms manufacturers and military contractors. We ' +
            'also show if a fund has a sustainability mandate, or is a ' +
            'member of The Forum for Sustainable and Responsible Investment ' +
            '(US-SIF). Click the column headers to sort the results. Click a ' +
            'row to see the full profile for that fund.'
        }
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for military weapon companies.'
        }
      ]),
      'Gun Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a gun grade, and the ' +
            'percentage of the fund\'s assets invested in gun companies. We ' +
            'also show if a fund has a sustainability mandate, or is a ' +
            'member of The Forum for Sustainable and Responsible Investment ' +
            '(US-SIF). Click the column headers to sort the results. Click a ' +
            'row to see the full profile for that fund.'
        }
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for gun companies.'
        }
      ]),
      'Tobacco Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a tobacco grade, and the ' +
            'percentage of the fund\'s assets invested in tobacco companies. ' +
            'We also show if a fund has a sustainability mandate, or is a ' +
            'member of The Forum for Sustainable and Responsible Investment ' +
            '(US-SIF). Click the column headers to sort the results. Click a ' +
            'row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for tobacco companies.'
        }
      ]),
      'Deforestation Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a deforestation grade, ' +
            'and the percent of different deforestation-risk holdings. We ' +
            'also show if a fund has a sustainable investing mandate, or is ' +
            'a member of The Forum for Sustainable and Responsible ' +
            'Investment (US-SIF). Click the column headers to sort the ' +
            'results. Click a row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for deforestation risk.'
        }
      ]),
      'Fossil Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a fossil fuel grade, ' +
            'fossil finance and insurance scores, and the percent invested in Clean200 companies. We ' +
            'also show if a fund has a sustainable investing mandate, or is ' +
            'a member of The Forum for Sustainable and Responsible ' +
            'Investment (US-SIF). Click the column headers to sort the ' +
            'results. Click a row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for fossil fuels.'
        }
      ]),
      'Gender Equality Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a gender equality score, ' +
            'and a grade based on where the fund ranks in its group. We ' +
            'also show if a fund has a sustainable investing mandate, or is ' +
            'a member of The Forum for Sustainable and Responsible ' +
            'Investment (US-SIF). Click the column headers to sort the ' +
            'results. Click a row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for gender equality scores.'
        }
      ]),

      'Social Justice Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'Click the column headers to sort the ' +
            'results. Click a row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds for social justice scores.'
        }
      ]),

      'Prison Free Funds' : tutorialStep1.concat([
        {
          headline: 'Step 2: See your results',
          copy: 'For each result, we\'ll show a prison industrial complex grade, and the ' +
            'percentage of the fund\'s assets invested in prison and border/immigration companies. ' +
            'We also show if a fund has a sustainability mandate, or is a ' +
            'member of The Forum for Sustainable and Responsible Investment ' +
            '(US-SIF). Click the column headers to sort the results. Click a ' +
            'row to see the full profile for that fund.'
        },
      ]).concat(tutorialSteps3).concat([
        {
          headline: 'You\'re ready!',
          copy: 'Get started checking your funds.'
        }
      ]),
    }

    this.state = {
      tutorialContent
    }
  }
  //
  render() {
    // logic to choose tutorial content
    // - headline
    // - dialog copy
    // - what other component has styling adjusted for overlay z-index
    // - is next button shown or hidden

    // sanity check
    const currentTutOpts = this.state.tutorialContent[config.app.title]
    if (
      !this.props.showTutorial ||
      this.props.currentTutorial >= currentTutOpts.length
    ) {
      // shouldn't get here
      return null
    }
    const showNext = this.props.currentTutorial < currentTutOpts.length - 1
    const showPrev = this.props.currentTutorial > 0
    const thisTutorialContent = currentTutOpts[this.props.currentTutorial]

    return <div>
      <IyvListTutorialOverlay
        showTutorial={this.props.showTutorial}
        clickCloseTutorial={this.props.clickCloseTutorial}
      />
      <div styleName={'tutorial-wrap-' + this.props.currentTutorial}>
        <div styleName='tutorial-dialog'>
          <div styleName='tutorial-dialog-inner'>
            <div styleName='tutorial-headline'>
              {thisTutorialContent.headline}
            </div>
            <div styleName='tutorial-content'>
              <div styleName='tutorial-copy'>
                {thisTutorialContent.copy}
              </div>
              <div styleName='tutorial-nav'>
                { /* don't show the prev button on the first tutorial */
                  showPrev ?
                    (
                      <button
                        styleName='tutorial-prev'
                        onClick={this.props.clickPrevTutorial}
                        title='Previous'
                        role='button'
                        tabIndex='0'
                      >
                        <LinkIcon nospace faclass='fa-angle-double-left'/>
                      </button>
                    ) :
                    null
                }
                { /* don't show the next button on the last tutorial */
                  showNext ?
                    (
                      <button
                        styleName='tutorial-next'
                        onClick={this.props.clickNextTutorial}
                        title='Next'
                        role='button'
                        tabIndex='0'
                      >
                        <LinkIcon nospace/>
                      </button>
                    ) :
                    null
                }
                <button
                  styleName='tutorial-close'
                  onClick={this.props.clickCloseTutorial}
                  title='Close'
                  role='button'
                  tabIndex='0'
                >
                  <LinkIcon nospace faclass='fa-close'/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

